<div class="app-menu navbar-menu">
  <!-- LOGO -->
  <div class="navbar-brand-box">
    <!-- Dark Logo-->
    <a routerLink="/" class="logo logo-dark">
      <span class="logo-sm">
        <img src="assets/images/logo-dark-sm.svg" alt="" height="28">
      </span>
      <span class="logo-lg">
        <img src="assets/images/logo-dark.svg" alt="" height="36">
      </span>
    </a>
    <!-- Light Logo-->
    <a routerLink="/" class="logo logo-light">
      <span class="logo-sm">
        <img src="assets/images/logo-light-sm.svg" alt="" height="28">
      </span>
      <span class="logo-lg">
        <img src="assets/images/logo-light.svg" alt="" height="36">
      </span>
    </a>
    <button type="button" class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover" id="vertical-hover">
      <i class="ri-record-circle-line"></i>
    </button>
  </div>

  <div id="scrollbar">
    <div class="container-fluid">

      <div id="two-column-menu">
      </div>
      <ul class="navbar-nav" id="navbar-nav">
        @for (item of menuItems; track item.id) {
        @if (item.isTitle) {
        <li class="menu-title"><span data-key="t-menu">{{ item.label | translate
            }}</span></li>
        }
        @if (!item.isTitle && !item.isLayout) {
        <li class="nav-item">
          @if (hasItems(item)) {
          <a href="javascript:void(0);" class="is-parent nav-link menu-link" [class.has-arrow]="!item.badge"
            [class.has-dropdown]="item.badge" [class.disabled]="item.disabled" [class.opacity-50]="item.disabled"
            data-bs-toggle="collapse" aria-expanded="false" (click)="toggleItem($event)">
            <i class="{{ item.icon }} icon nav-icon" class=""></i>
            <span class=""> {{ item.label | translate }}</span>
            @if (item.badge) {
            <span class="badge badge-pill {{item.badge.variant}}">
              {{item.badge.text | translate}}
            </span>
            }
          </a>
          }
          @if (!hasItems(item)) {
          <a [routerLink]="item.link" class="side-nav-link-ref nav-link menu-link" [class.disabled]="item.disabled"
            [class.opacity-50]="item.disabled">
            @if (item.icon) {
            <i class="bx {{ item.icon }} icon nav-icon" class=""></i>
            }
            <span class=""> {{ item.label | translate }}</span>
            @if (item.badge) {
            <span class="badge {{item.badge.variant}} float-end">
              {{item.badge.text | translate}}
            </span>
            }
          </a>
          }
          @if (hasItems(item)) {
          <div class="collapse menu-dropdown" id="sidebarDashboards">
            @if (hasItems(item)) {
            <ul class="nav nav-sm flex-column" aria-expanded="false">
              @for (subitem of item.subItems; track subitem.id) {
              <li class="nav-item">
                @if (!hasItems(subitem)) {
                <a [routerLink]="subitem.link" class="nav-link" [attr.data-parent]="subitem.parentId"
                  (click)="updateActive($event)">
                  @if (subitem.icon) {
                  <i class="bx {{ subitem.icon }} icon nav-icon" class=""></i>
                  }{{ subitem.label | translate}}
                </a>
                }
                @if (hasItems(subitem)) {
                <a class="nav-link" href="javascript:void(0);" [attr.data-parent]="subitem.parentId"
                  data-bs-toggle="collapse" aria-expanded="false" (click)="toggleSubItem($event)">
                  @if (subitem.icon) {
                  <i class="bx {{ subitem.icon }} icon nav-icon" class=""></i>
                  }{{ subitem.label | translate}}
                </a>
                }
                @if (hasItems(subitem)) {
                <div class="collapse menu-dropdown">
                  <ul class="nav nav-sm flex-column" aria-expanded="false">
                    @for (subSubitem of subitem.subItems; track subSubitem.id) {
                    <li class="nav-item">
                      @if (!subSubitem.childItem) {
                      <a [attr.data-parent]="subSubitem.parentId" [routerLink]="subSubitem.link" class="nav-link"
                        (click)="updateActive($event)">
                        {{ subSubitem.label | translate }}
                      </a>
                      }
                      @if (subSubitem.childItem) {
                      <a [attr.data-parent]="subSubitem.parentId" [routerLink]="subSubitem.link"
                        data-bs-toggle="collapse" aria-expanded="false" class="nav-link" (click)="updateActive($event)">
                        {{ subSubitem.label | translate }}
                      </a>
                      }
                      @if (subSubitem.childItem) {
                      <div class="collapse menu-dropdown">
                        <ul class="nav nav-sm flex-column" aria-expanded="false">
                          @for (subChilditem of subSubitem.childItem; track subChilditem.id) {
                          <li class="nav-item">
                            <a [attr.data-parent]="subSubitem.parentId" [routerLink]="subChilditem.link"
                              class="nav-link" (click)="updateActive($event)">
                              {{ subChilditem.label | translate }}
                            </a>
                          </li>
                          }
                        </ul>
                      </div>
                      }
                    </li>
                    }
                  </ul>
                </div>
                }
              </li>
              }
            </ul>
            }
          </div>
          }
        </li>
        }
        }
        <ng-container>
          <li class="nav-item">
            <a class="side-nav-link-ref nav-link menu-link"
              href="https://forms.clickup.com/42085814/f/184bdp-2200/6IUCHV40DA7J5AED2H" target="_blank" rel="noopener">
              <i class="bx bx-support icon nav-icon"></i>
              <span> {{ 'COMMON.SUPPORT' | translate}} </span>
            </a>
          </li>
        </ng-container>
      </ul>
    </div>
    <!-- Sidebar -->
  </div>
</div>